export const getLocalWishlist = () => {
  return JSON.parse(localStorage.getItem("wishlist")) || [];
};

export const addToLocalWishlist = (productId) => {
  const wishlist = getLocalWishlist();
  if (!wishlist.includes(productId)) {
    wishlist.push(productId);
    localStorage.setItem("wishlist", JSON.stringify(wishlist));
  }
};

export const removeFromLocalWishlist = (productId) => {
  const wishlist = getLocalWishlist().filter(id => id !== productId);
  localStorage.setItem("wishlist", JSON.stringify(wishlist));
};

export const isInLocalWishlist = (productId) => {
  return getLocalWishlist().includes(productId);
};
